import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { ofActionCompleted, Select } from '@ngxs/store';
import { Subject } from 'rxjs';
import { OnboardingState } from '../../states/onboarding.state';
import { FetchOnboardingGoals } from '../../states/onboarding.actions';
import { takeUntil } from 'rxjs/operators';
import ResponseHandlingHelper from '../../helpers/response-handling-helper';
import { PushMenuActiveAccountId } from 'src/app/states/menu.actions';
import { HttpErrorCode } from 'src/app/api/http-error-code.enum';
export class OnboardingPageComponent {
    constructor(store, actions, router, route, title) {
        this.store = store;
        this.actions = actions;
        this.router = router;
        this.route = route;
        this.title = title;
        this.goals = [];
        this.isLoading = false;
        this.cancellationToken = new Subject();
        this.gc = new Subject();
        this.sortColumn = '';
        this.sortDirection = 'asc';
    }
    ngOnInit() {
        this.title.setTitle('Onboarding - Dataedo Account');
        this.initEvents();
    }
    fetchData() {
        this.cancellationToken.next();
        this.isLoading = true;
        this.store.dispatch(new FetchOnboardingGoals(this.accountId, this.cancellationToken));
    }
    initEvents() {
        this.route.params
            .pipe(takeUntil(this.gc))
            .subscribe(params => this.onPathChange(params));
        this.goalsListener
            .pipe(takeUntil(this.gc))
            .subscribe(goals => this.goals = goals);
        this.actions
            .pipe(ofActionCompleted(FetchOnboardingGoals))
            .pipe(takeUntil(this.gc))
            .subscribe(event => this.onCompletedFetchGoals(event));
    }
    onPathChange(params) {
        this.accountId = parseInt(params.accountId, 10);
        this.store.dispatch(new PushMenuActiveAccountId(this.accountId));
        this.fetchData();
    }
    onCompletedFetchGoals(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = ResponseHandlingHelper.parse(event.result);
            if (response.isError && response.error.status === HttpErrorCode.Forbidden) {
                yield this.router.navigate(['/accounts', this.accountId]);
            }
            this.isLoading = false;
        });
    }
    getStatusDotColor(status) {
        switch (status.toUpperCase()) {
            case 'COMPLETED':
                return '#34c759'; // Green
            case 'IN_PROGRESS':
                return '#f4b400'; // Yellow
            case 'CONSULTING':
                return '#1e88e5'; // Blue
            case 'ACKNOWLEDGED':
                return '#9e9e9e'; // Grey
            default:
                return '#ccc'; // Default grey
        }
    }
    getStatusLabel(status) {
        switch (status.toUpperCase()) {
            case 'COMPLETED':
                return 'Done';
            case 'IN_PROGRESS':
                return 'In progress';
            case 'CONSULTING':
                return 'Consulting';
            case 'ACKNOWLEDGED':
                return 'Acknowledged';
            default:
                return status;
        }
    }
    trackById(index, goal) {
        return goal.id;
    }
    ngOnDestroy() {
        this.cancellationToken.next();
        this.cancellationToken.complete();
        this.gc.next();
        this.gc.complete();
    }
    sortGoals(column) {
        if (!this.goals) {
            return;
        }
        if (this.sortColumn === column) {
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        }
        else {
            this.sortColumn = column;
            this.sortDirection = 'asc';
        }
        const sorted = [...this.goals].sort((a, b) => {
            let aVal = a[column];
            let bVal = b[column];
            if (aVal == null) {
                return 1;
            }
            if (bVal == null) {
                return -1;
            }
            // Convert to timestamp if it's a date
            if (column.includes('date') || column.includes('updated_at') || column.includes('status_changed_at')) {
                aVal = new Date(aVal).getTime();
                bVal = new Date(bVal).getTime();
            }
            if (aVal < bVal) {
                return this.sortDirection === 'asc' ? -1 : 1;
            }
            if (aVal > bVal) {
                return this.sortDirection === 'asc' ? 1 : -1;
            }
            return 0;
        });
        this.goals = sorted;
    }
}
tslib_1.__decorate([
    Select(OnboardingState.orders)
], OnboardingPageComponent.prototype, "goalsListener", void 0);
